import React from 'react'
import styles from './TileButton.module.css'

export const TileButton = ({onClick, buttonText, imageSrc, imageAlt, dataClickLabel, selected = false}) => {

    return (
        <button
            onClick={onClick}
            className={`${styles.button} ${selected ? styles.selected : ''}`}
            type={'button'}
            data-click-label={dataClickLabel}
        >
            <div className={styles.content}>
                <img src={imageSrc} alt={imageAlt} className={styles.icon} />
                <span className={styles.text}>{buttonText}</span>
            </div>
            <img src='/entry_form_slide_app/steps/step1/rightArrow.svg' alt='矢印' className={styles.arrow} />
        </button>
    );
}
